<template>
	<div id="qs_center2">
		<div class="cc-header">学生评价完成率
			<div class="title_tab">
				<div class="tab_line" style="margin-right: 5px;">
					<div class="legend-color" style="background-color: #01dde5;"></div> 日常评价
				</div>
				<div class="tab_line">
					<div class="legend-color" style="background-color: #ffaa00;"></div> 综合素质评价
				</div>
			</div>
		</div>
		<div class="main-value" id="apply_click"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
let pageSize = 9; //echarts每页显示数量
let evalCompleteByGradeChart;
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval1 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
		// 定时器轮播，5秒
		this.interval2 = setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	},
	methods: {
		//echarts图标数据过多时，x轴自动滑动
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				evalCompleteByGradeChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			evalCompleteByGradeChart = echarts.init(document.getElementById("apply_click"));
			this.$http.get("/dataView/quality/getEvalCompleteByGrade?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.total = result.xDatas.length;
					var option = {
						color: ['#01dde5', '#ffaa00'],
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							},
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '%</b>';
								}
								return relVal
							}
						},
						grid: {
							x: 76,
							top: "10%",
							bottom: "25%",
						},
						xAxis: [{
							type: 'category',
							data: result.xDatas,
							axisLabel: {
								interval: 0,
								rotate: 40,
								textStyle: {
									color: '#55aaff',
									fontSize: fontSize(0.15)
								}
							},
							axisLine: {
								show: true
							},
						}],
						yAxis: [{
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#55aaff',
									fontSize: fontSize(0.15)
								},
								formatter: '{value}%'
							},
							axisLine: {
								show: true
							},
						}],
						series: [{
							type: 'line',
							name: '日常评价',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#1cfcff" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#aaff7f" // 100% 处的颜色
								}])
							},
							emphasis: {
								focus: 'series'
							},
							data: result.ydatas2
						},
						{
							type: 'line',
							name: '综合素质评价',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#ffce3a" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#da5b35" // 100% 处的颜色
								}])
							},
							emphasis: {
								focus: 'series'
							},
							data: result.ydatas1
						}
						]
					};
					evalCompleteByGradeChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => evalCompleteByGradeChart.resize(), false);
				}
			});
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#qs_center2 {
	height: 100%;
	padding: 0 3%;

	.cc-header {
		width: 100%;
		padding-top: 1%;
		color: #55ffff;
		font-size: 0.3rem;
		display: flex;
		align-items: center;
		position: relative;

		.title_tab {
			position: absolute;
			right: 0.2rem;
			font-size: 0.2rem;
			height: 0.2rem;
			display: flex;
			align-items: center;
			color: #d3d6ff;

			.legend-color {
				display: inline-block;
				width: 0.3rem;
				height: 0.2rem;
				border-radius: 0.05rem;
				margin-right: 0.05rem;
				vertical-align: text-bottom;
			}
		}
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {
		.cc-header {
			height: 25%;
			padding-left: 3%;
		}

		.main-value {
			height: 75%;
		}
	}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {
		.cc-header {
			height: 20%;
			padding-left: 3%;
		}

		.main-value {
			height: 80%;
		}
	}
}
</style>
